import type { JuiceParticle } from './Particle.ts';

/**
 * Pre-allocated pool of JuiceParticle objects — avoids per-spawn allocation.
 * Dead particles (alpha ≤ 0.02) are returned to the pool by RemoteFruitDisplayEngine
 * during the in-place tick sweep and reused for the next spawn.
 */
export class JuiceParticlePool {
  private readonly pool: JuiceParticle[] = [];

  acquire(
    x: number,
    y: number,
    vx: number,
    vy: number,
    radius: number,
    color: string,
  ): JuiceParticle {
    const p = this.pool.pop();
    if (p) {
      p.x = x;
      p.y = y;
      p.vx = vx;
      p.vy = vy;
      p.radius = radius;
      p.color = color;
      p.alpha = 1;
      return p;
    }
    return { kind: 'juice', x, y, vx, vy, radius, color, alpha: 1 };
  }

  release(p: JuiceParticle): void {
    this.pool.push(p);
  }

  get size(): number {
    return this.pool.length;
  }
}
